"use client";

import { MultiStepForm } from './components/MultiStepForm';
import { partnerProgramFormConfig } from './PartnerProgramFormConfig';

export const PartnerProgramForm = () => {
  return (
    <MultiStepForm 
      config={partnerProgramFormConfig}
      className="partner-program-form"
    />
  );
} 